import axios from 'axios'

// const andPoint = 'http://mobilisedev.co.uk:3000'
// 'https://cors-anywhere.herokuapp.com/https://devapi.mobilisehotspots.com:7450/mconnect'

axios.defaults.headers.common['Authorization'] = `Bearer ${
  localStorage.getItem('token') || Math.random().toFixed(21).substring(2)
}`

export const ApiPost = (url: string, parameters: { [propName: string]: any }, header: any = {}) =>
  axios
    .post(process.env.REACT_APP_API_PORTAL_ADDRESS + url, parameters, header)
    .then((response) => {
      return {
        ...response,
        status: true,
      }
    })
    .catch((error) => {
      console.log('ApiPost error-response', error.response)

      if (error.response.data.message === 'Invalid Token') {
        window.location.replace(`${window.location.origin}/login`)
      }
      return {
        ...error.response,
        status: false,
      }
    })

export const ApiGet = (url: string) =>
  axios
    .get(process.env.REACT_APP_API_PORTAL_ADDRESS + url)
    .then((response) => {
      return {
        ...response,
        status: true,
      }
    })
    .catch((error) => {
      console.log('ApiGet error', error.response)

      if (error.response.data.message === 'Invalid Token') {
        window.location.replace(`${window.location.origin}/login`)
      }

      return {
        ...error.response,
        status: false,
      }
    })

export const ApiPut = (url: string, parameters: { [propName: string]: any }) =>
  axios
    .put(process.env.REACT_APP_API_PORTAL_ADDRESS + url, parameters)
    .then(function (response) {
      return {
        ...response,
        status: true,
      }
    })
    .catch(function (error) {
      console.log('ApiPut response error', error.response)

      if (error.response.data.message === 'Invalid Token') {
        window.location.replace(`${window.location.origin}/login`)
      }
      return {
        ...error.response,
        status: false,
      }
    })

export const ApiDelete = (url: string) =>
  axios
    .delete(process.env.REACT_APP_API_PORTAL_ADDRESS + url)
    .then(function (response) {
      return {
        ...response,
        status: true,
      }
    })
    .catch(function (error) {
      console.log('ApiDelete response error', error.response)

      if (error.response.data.message === 'Invalid Token') {
        window.location.replace(`${window.location.origin}/login`)
      }
      return {
        ...error.response,
        status: false,
      }
    })
